import { BasicPage } from '../components/BasicPage';
import Settings from '@mui/icons-material/Settings';
import NoData from '../hoc/noData';

export const SettingsPage = () => {
  // return <BasicPage title="Settings Page"  icon={<Settings />} />;
  return <NoData/>;
};
